import {EditableInput} from '../../../../layout/editable-input/editable-input';
import {LangKeyType} from '../../../../provider/locale/translation/type';
import {
    defaultResponseTemplateData,
    ResponseTemplateGroupType,
} from '../../../../service/reviews/reviews-response-templates';

export function renderGroupName(
    tagData: ResponseTemplateGroupType,
    getLocalizedString: (langKey: LangKeyType) => string,
    onSave?: (text: string) => void,
    editableId?: number
): JSX.Element {
    const {title, id} = tagData;

    if (id !== defaultResponseTemplateData.id && id !== editableId) {
        return <span>{title}</span>;
    }

    return (
        <EditableInput
            hasButton={false}
            initialValue={title}
            isDefaultActive
            onSave={onSave}
            placeholder={getLocalizedString('RESPONSE_TEMPLATES__ENTER_GROUP_NAME')}
        />
    );
}
